import { Component, OnInit } from '@angular/core';
import {WidgetBaseComponent} from '../widget-base/widget-base.component';
import {TabElement} from './Data/tab-element';
import {DoraProperty, DoraPropertyArray} from '../../Decorators/Decorator';

@Component({
  selector: 'dora-tab',
  templateUrl: './dora-tab.component.html',
  styleUrls: ['./dora-tab.component.scss']
})
export class DoraTabComponent extends WidgetBaseComponent {
private defaultTabIdx = 0;

@DoraPropertyArray (TabElement)
protected tabElements: TabElement[] = [];

  onParameterInjectedFinished(): void {
    super.onParameterInjectedFinished();

    // todo Temporaneo per test
    // this.tabElements.push(new TabElement('Completo', 'tab1-id', false));
    // this.tabElements.push(new TabElement('Singolo chart', 'tab2-id', false));

    // select default
    if (this.defaultTabIdx < this.tabElements.length) {
      this.onSelect(this.defaultTabIdx, this.tabElements[this.defaultTabIdx]);
    }
  }

  // CSS
  protected getTabContainerCssClass(tabIdx: number, tabElement: TabElement): string {
    let result = 'DAG-container';

    if (tabElement.active) {
      result += ' DAG-active';
    }
    return  result;
  }
  protected getElementContentCssClass(tabIdx: number, tabElement: TabElement): string {
    return  'DAG-content';
  }
  // Content
  protected getElementContent(tabIdx: number, tabElement: TabElement): string {
    return  tabElement.name;
  }
  // User interaction
  protected onSelect(tabIdx: number, tabElement: TabElement): void {
    this.tabElements.forEach(x => {
      if (x.elementReferenceId === tabElement.elementReferenceId) {
        // select
        x.active = true;
        document.getElementById(x.elementReferenceId).classList.remove('DAG-hide');
        document.getElementById(x.elementReferenceId).classList.add('DAG-show');
      } else {
        // unselect
        x.active = false;
        document.getElementById(x.elementReferenceId).classList.remove('DAG-show');
        document.getElementById(x.elementReferenceId).classList.add('DAG-hide');
      }
    });
  }
}
